import { useEffect, useRef } from 'react';
import { useApiContext } from 'react-easyrocket';
import { useModalContext } from 'src/hooks/useModalContext';

type onSuccessType = () => void;

/** Отвечает за сохранение коллбэка onSuccess и вызов его как только
 * пользователь становится авторизованным. Вызвать в роутере один раз без параметров
 */
export const useAuthFlowSuccessCallback = () => {
  const { openedModalName, modalProps } = useModalContext<{
    onAuthFlowSuccess: onSuccessType;
  }>();
  const onSuccessRef = useRef<onSuccessType | null>(null);
  const { isAuthenticated } = useApiContext();

  useEffect(() => {
    if (
      !isAuthenticated &&
      (openedModalName === 'SIGNUP' || openedModalName === 'LOGIN') &&
      typeof modalProps?.onAuthFlowSuccess === 'function'
    ) {
      onSuccessRef.current = modalProps.onAuthFlowSuccess;
    }
    if (
      isAuthenticated &&
      openedModalName !== 'SIGNUP' &&
      openedModalName !== 'LOGIN' &&
      onSuccessRef.current
    ) {
      onSuccessRef.current();
      onSuccessRef.current = null;
    }
  }, [openedModalName]);
};
